var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 54,
    viewBox: "0 0 38 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 51C10.9999 52.4667 12.1999 53.6667 13.6666 53.6667H24.3333C25.7999 53.6667 26.9999 52.4667 26.9999 51V48.3333H10.9999V51ZM18.9999 0.333328C8.70659 0.333328 0.333252 8.70666 0.333252 19C0.333252 25.3467 3.50659 30.92 8.33325 34.3067V40.3333C8.33325 41.8 9.53325 43 10.9999 43H26.9999C28.4666 43 29.6666 41.8 29.6666 40.3333V34.3067C34.4933 30.92 37.6666 25.3467 37.6666 19C37.6666 8.70666 29.2933 0.333328 18.9999 0.333328ZM26.5999 29.9333L24.3333 31.5333V37.6667H13.6666V31.5333L11.3999 29.9333C7.79992 27.4267 5.66659 23.3467 5.66659 19C5.66659 11.64 11.6399 5.66666 18.9999 5.66666C26.3599 5.66666 32.3333 11.64 32.3333 19C32.3333 23.3467 30.1999 27.4267 26.5999 29.9333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.a124a747073e6819a2a516f617cac6f3.svg";
export { ForwardRef as ReactComponent };